export * from "./TrashCollectionLanding";
